const E = "preference/GET_ALL_PREFERENCES_SUCCESS", _ = "preference/UPDATE_INDIVIDUAL_PREFERENCE";
export {
  E as GET_ALL_PREFERENCES_SUCCESS,
  _ as UPDATE_INDIVIDUAL_PREFERENCE
};
//# sourceMappingURL=types.js.map
